type MobileLogoProps = {
	className?: string
}
export default function MobileLogo({ className = 'fill-black w-6' }) {
	return (
		<svg viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.5 0H15.4077C18.7724 0 21.5 2.72759 21.5 6.09225C21.5 8.42243 20.1918 10.4471 18.2698 11.4718C20.7389 12.3803 22.5 14.7533 22.5 17.5376C22.5 21.1062 19.6071 23.9991 16.0385 23.9991H0.5V12.1845V11.0762V0ZM15.1507 11.919L10.6211 7.38477L6.09153 11.919L10.6211 16.4532L15.1507 11.919Z"
			/>
		</svg>
	)
}
